/**
 * Created by fers on 18.02.16.
 */

import Crossing from 'crossing';
import immutable from 'immutable';

import { fromGlobalId } from 'graphql-relay';
import {safeJSONparse} from "../../common/util/safeJSONparse";

// create your crossing instance
let urls = new Crossing();

let myUrls = {
    "organisations:list":       "/organisations/",
    "organisations:edit":       "/organisations/<id>/edit/",
    "organisations:logger":     "/organisations/<id>/logger/",
    "organisations:billing":    "/organisations/<id>/billing/",
    "organisations:hooks":      "/organisations/<id>/hooks/",
    "organisations:view":       "/organisations/<id>/",
    "organisations:create":     "/organisations/add/",
    "organisations:instance-list": "/instances/<id>/organisations/",
    "organisations:scenarios-list": "/s/<urlFragment>/organisations/",
    "organisations:instance-list-search":"/instances/<id>/organisations/by-name/<name>/",
    "organisations:instance-view": "/instances/<instance_id>/organisations/<id>/",
    "usedScenarios:list":       "/organisations/<id>/used-scenarios/",
    "organisations:runningJobs":"/organisations/<id>/running-jobs/",

    "organisationEvents:list-org":"/organisations/<id>/events/",
    "organisationEvents:list-flow":"/organisations/<organisation_id>/flows/<id>/events/",
    "organisationEvents:list-channel":"/organisations/<organisation_id>/channels/<id>/events/",

    "organisationNotifications:list":"/organisations/<id>/notifications/",
    "organisationNotifications:list-flow":"/organisations/<organisation_id>/flows/<id>/notifications/",
    "organisationNotifications:list-consultant":"/settings/consultants/notifications/",

    "organisationNotifications:view":"/organisations/<organisation_id>/notifications/<id>/",

    "organisation2user:edit":   "/organisations/<organisation_id>/organisation2user/<id>/",
    "organisation2user:view":   "/organisations/<organisation_id>/organisation2user/<id>/",
    "organisation2user:list":   "/organisations/<id>/users/",

    "users:list":               "/organisations/<id>/users/",
    "users:edit":               "/organisations/<organisation_id>/users/<id>/edit/",
    "users:view":               "/organisations/<organisation_id>/users/<id>/",
    "users:instance-list":      "/instances/<id>/users/",
    "users:instance-list-search":"/instances/<id>/users/by-email/<email>/",
    "users:instance-view":      "/instances/<instance_id>/users/<id>/",
    "users:instance-edit":      "/instances/<instance_id>/users/<id>/edit/",
    "users:instance-notifications":      "/instances/<instance_id>/users/<id>/notifications/",

    "announcements:list":                "/instances/<id>/announcements/",
    "announcements:edit":                "/instances/<instance_id>/announcements/<id>/edit/",
    "announcements:view":                "/instances/<instance_id>/announcements/<id>/",
    "announcements:create":              "/instances/<id>/announcements/add/",


	"user:settings":            "/settings/",
	"user:edit":            	"/settings/edit/",
    "user:notifications":       "/settings/notifications/",

    "apiKeys:list":             "/organisations/<organisation_id>/users/<id>/api-keys/",
    "apiKeys:edit":             "/organisations/<organisation_id>/users/<user_id>/api-keys/<id>/edit/",
    "apiKeys:view":             "/organisations/<organisation_id>/users/<user_id>/api-keys/<id>/",
    "apiKeys:create":           "/organisations/<organisation_id>/users/<id>/api-keys/add/",

    "channels:list":            "/organisations/<id>/",
    "channels:confidential":    "/organisations/<organisation_id>/channels/<id>/confidential/",
    "channels:caching":         "/organisations/<organisation_id>/channels/<id>/caching/",
    "channels:edit":            "/organisations/<organisation_id>/channels/<id>/edit/",
    "channels:logger":          "/organisations/<organisation_id>/channels/<id>/logger/",
    "channels:oauth-callback":  "/organisations/<organisation_id>/channels/<id>/oauth-callback/",
    "channels:options":         "/organisations/<organisation_id>/channels/<id>/options/",
    "channels:view":            "/organisations/<organisation_id>/channels/<id>/",
    "channels:create":          "/organisations/<id>/channels/add/",
    "channels:create-step-1":   "/organisations/<organisation_id>/channels/add-step/1/<id>/",
    "channels:create-step-2":   "/organisations/<organisation_id>/channels/add-step/2/<id>/",
    "channels:create-step-3":   "/organisations/<organisation_id>/channels/add-step/3/<id>/",
    "channels:create-step-4":   "/organisations/<organisation_id>/channels/add-step/4/<id>/",
    "channels:create-step-5":   "/organisations/<organisation_id>/channels/add-step/5/<id>/",
    "channels:scenario-create-step-1":   "/organisations/<organisation_id>/channels/scenarios/<scenario_id>/add-step/1/<id>/",
    "channels:scenario-create-step-2":   "/organisations/<organisation_id>/channels/scenarios/<scenario_id>/add-step/2/<id>/",
    "channels:scenario-create-step-3":   "/organisations/<organisation_id>/channels/scenarios/<scenario_id>/add-step/3/<id>/",
    "channels:scenario-create-step-4":   "/organisations/<organisation_id>/channels/scenarios/<scenario_id>/add-step/4/<id>/",
    "channels:scenario-create-step-5":   "/organisations/<organisation_id>/channels/scenarios/<scenario_id>/add-step/5/<id>/",
    "channels:scenario-apply":   "/organisations/<organisation_id>/channels/scenarios/<urlFragment>/<scenario_id>/apply/",
    "channels:create-pre":       "/apps/<urlFragment>/add/",
    "channels:create-pre-auto":  "/apps/<urlFragment>/add/auto/",
    "channelDefs:public-apps":   "/apps/<urlFragment>/",
    "channels:instance-list-special-prices":"/instances/<id>/channels-special-prices/",

    "flows:list":               "/organisations/<id>/flows/",
    "flows:edit":               "/organisations/<organisation_id>/flows/<id>/edit/",
    "flows:hooks":              "/organisations/<organisation_id>/flows/<id>/hooks/",
    "flows:logger":             "/organisations/<organisation_id>/flows/<id>/logger/",
    "flows:channel-config":     "/organisations/<organisation_id>/flows/<id>/channel-config/",
    "flows:config":             "/organisations/<organisation_id>/flows/<id>/config/",
    "flows:runningJobs":        "/organisations/<organisation_id>/flows/<id>/running-jobs/",
    "flows:coordinations":        "/organisations/<organisation_id>/flows/<id>/coordinations/",
    "flows:view":               "/organisations/<organisation_id>/flows/<id>/",
    "flows:create":             "/organisations/<id>/flows/add/",
    "flows:create-step-1":      "/organisations/<organisation_id>/flows/add-step/1/<id>/",
    "flows:create-step-4":      "/organisations/<organisation_id>/flows/add-step/4/<id>/",
    "flows:instance-list":      "/instances/<id>/flows/",
    "flows:instance-list-special-prices":"/instances/<id>/flows-special-prices/",
    "flows:scenarios-list":     "/s/<urlFragment>/flows/",
    "flows:instance-list-billed":      "/instances/<id>/flows-billed-all/",
    "flows:instance-list-not-billed":      "/instances/<id>/flows-notBilled-all/",
    "flows:instance-view":      "/instances/<instance_id>/flows/<id>/",
    "flows:instance-edit":      "/instances/<instance_id>/flows/<id>/edit/",
    "flows:instance-move":      "/instances/<instance_id>/flows/<id>/move/",
    "flows:instance-billing":   "/instances/<instance_id>/flows/<id>/billing/",

    "flowInvocations:view":             "/organisations/<organisation_id>/flows/<flow_id>/invocations/<id>/",
    "flowInvocations:logger":           "/organisations/<organisation_id>/flows/<flow_id>/invocations/<id>/logger/",
    "flowInvocations:list":             "/organisations/<organisation_id>/flows/<id>/invocations-all/all/",
    "flowInvocations:list-all":         "/organisations/<organisation_id>/flows/<id>/invocations-all/<startType>/",
    "flowInvocations:list-success":     "/organisations/<organisation_id>/flows/<id>/invocations-success/<startType>/",
    "flowInvocations:list-fail":        "/organisations/<organisation_id>/flows/<id>/invocations-fail/<startType>/",
    "flowInvocations:list-org":         "/organisations/<id>/invocations/",
    "flowInvocations:list-org-success": "/organisations/<id>/invocations-success/",
    "flowInvocations:list-org-fail":    "/organisations/<id>/invocations-fail/",
    "flowInvocations:list-flowDef":     "/flow-defs/<id>/invocations/",
    "flowInvocations:list-flowDef-success":"/flow-defs/<id>/invocations-success/",
    "flowInvocations:list-flowDef-fail":"/flow-defs/<id>/invocations-fail/",
    "flowIncomingEmails:view":             "/organisations/<organisation_id>/flows/<flow_id>/emails/<id>/",
    "flowIncomingEmails:list":             "/organisations/<organisation_id>/flows/<id>/emails/",
    "flowIncomingEmails:list-unprocessed":     "/organisations/<organisation_id>/flows/<id>/emails-unprocessed/",
    "flowIncomingEmails:list-failed":        "/organisations/<organisation_id>/flows/<id>/emails-failed/",

    "tasks:list":               "/organisations/<organisation_id>/flows/<id>/tasks/",
    "tasks:view":               "/organisations/<organisation_id>/flows/<flow_id>/tasks/<id>/",

    "dataSets:list":            "/organisations/<organisation_id>/channels/<id>/data-sets/",
    "dataSets:view":            "/organisations/<organisation_id>/channels/<channel_id>/data-sets/<id>/",

    "data:list":                "/organisations/<organisation_id>/channels/<channel_id>/data-sets/<id>/",
    "data:view":                "/organisations/<organisation_id>/channels/<channel_id>/data-sets/<dataSet_id>/<key>/",

    "relationDefs:list":        "/organisations/<id>/relations/",
    "relationDefs:edit":        "/organisations/<organisation_id>/relations/<id>/edit/",
    "relationDefs:view":        "/organisations/<organisation_id>/relations/<id>/",
    "relationDefs:create":      "/organisations/<id>/relations/add/",

    "billingRules:list":        "/organisations/<id>/billing-rules/",
    "billingRules:edit":        "/organisations/<organisation_id>/billing-rules/<id>/edit/",
    "billingRules:view":        "/organisations/<organisation_id>/billing-rules/<id>/",
    "billingRules:create":      "/organisations/<id>/billing-rules/add/",

    "fetches:view2":             "/organisations/<organisation_id>/fetches/<id>/",
    "fetches:list":             "/organisations/<organisation_id>/channels/<id>/fetches/",
    "fetches:view":             "/organisations/<organisation_id>/channels/<channel_id>/fetches/<id>/",
    "fetches:retry":            "/organisations/<organisation_id>/channels/<channel_id>/fetches/<id>/retry/",
    "fetches:list-success":     "/organisations/<organisation_id>/channels/<id>/fetches-success/",
    "fetches:list-fail":        "/organisations/<organisation_id>/channels/<id>/fetches-fail/",
    "fetches:list-flow":        "/organisations/<organisation_id>/flows/<id>/fetches/",
    "fetches:list-flow-success":"/organisations/<organisation_id>/flows/<id>/fetches-success/",
    "fetches:list-flow-fail":   "/organisations/<organisation_id>/flows/<id>/fetches-fail/",
    "fetches:list-flowInvocation":"/organisations/<organisation_id>/flows/<flow_id>/invocations/<id>/fetches/",
    "fetches:list-flowInvocation-success":"/organisations/<organisation_id>/flows/<flow_id>/invocations/<id>/fetches-success/",
    "fetches:list-flowInvocation-fail":"/organisations/<organisation_id>/flows/<flow_id>/invocations/<id>/fetches-fail/",
    "fetches:list-org":         "/organisations/<id>/fetches/",
    "fetches:list-org-success": "/organisations/<id>/fetches-success/",
    "fetches:list-org-fail":    "/organisations/<id>/fetches-fail/",
    "fetches:list-channelDef":  "/channel-defs/<id>/fetches/",
    "fetches:list-channelDef-success":"/channel-defs/<id>/fetches-success/",
    "fetches:list-channelDef-fail":"/channel-defs/<id>/fetches-fail/",
    "fetches:list-channelDef-unmarked":"/channel-defs/<id>/fetches-unmarked/",
    "fetches:list-flowDef":     "/flow-defs/<id>/fetches/",
    "fetches:list-flowDef-success":"/flow-defs/<id>/fetches-success/",
    "fetches:list-flowDef-fail":"/flow-defs/<id>/fetches-fail/",
    "fetches:list-instance":     "/instances/<id>/fetches/",
    "fetches:list-instance-success":"/instances/<id>/fetches-success/",
    "fetches:list-instance-fail":"/instances/<id>/fetches-fail/",

    "events:list":              "/organisations/<organisation_id>/channels/<id>/events/",
    "events:view":              "/organisations/<organisation_id>/channels/<channel_id>/events/<id>/",

    "screens:list":             "/organisations/<organisation_id>/channels/<id>/screens/",
    "screens:edit":             "/organisations/<organisation_id>/channels/<channel_id>/screens/<id>/edit/",
    "screens:view":             "/organisations/<organisation_id>/channels/<channel_id>/screens/<id>/",
    "screens:create":           "/organisations/<organisation_id>/channels/<id>/screens/add/",

    "channelAddons:list":       "/organisations/<organisation_id>/channels/<id>/addons/",
    "channelAddons:edit":       "/organisations/<organisation_id>/channels/<channel_id>/addons/<id>/edit/",
    "channelAddons:config":     "/organisations/<organisation_id>/channels/<channel_id>/addons/<id>/config/",
    "channelAddons:view":       "/organisations/<organisation_id>/channels/<channel_id>/addons/<id>/",
    "channelAddons:create":     "/organisations/<organisation_id>/channels/<id>/addons/add/",
    "channelAddons:create-step-1":"/organisations/<organisation_id>/channels/<channel_id>/addons/add-step/1/<addonDef_id>/",
    "channelAddons:create-step-2":"/organisations/<organisation_id>/channels/<channel_id>/addons/add-step/2/<addonDef_id>/",

    "jobs:list":                "/organisations/<id>/jobs/",
    "jobs:view":                "/organisations/<organisation_id>/jobs/<id>/",
    "jobs:user-list":           "/jobs/",
    "jobs:user-view":           "/jobs/<id>/",

    "invitations:list":         "/organisations/<id>/invitations/",
    "invitations:view":         "/organisations/<organisation_id>/invitations/<id>/",
    "invitations:create":       "/organisations/<id>/invitations/add/",
    "invitations:accept":       "/invitation/<id>/<secret>/",

    /* channels definition */
    "channelDefs:list":         "/channel-defs/",
    "channelDefs:list-placeholder":"/channel-defs/filter-placeholder/",
    "channelDefs:list-draft":   "/channel-defs/filter-draft/",
    "channelDefs:list-unsupported":"/channel-defs/filter-unsupported/",
    "channelDefs:list-published":"/channel-defs/filter-published/",
    "channelDefs:list-beta":    "/channel-defs/filter-beta/",
    "channelDefs:list-alpha":   "/channel-defs/filter-alpha/",
    "channelDefs:list-visible": "/channel-defs/filter-visible/",
    "channelDefs:edit":         "/channel-defs/<id>/edit/",
    "channelDefs:wizard":       "/channel-defs/<id>/wizard/",
    "channelDefs:datiQuery":    "/channel-defs/<id>/datiquery/",
    "channelDefs:view":         "/channel-defs/<id>/",
    "channelDefs:create":       "/channel-defs/add/",
    "channelDefs:dependantEntityViewDefs":"/channel-defs/<id>/views/",
    "channelDefs:scenarioDefs": "/channel-defs/<id>/scenario-defs/",
    "channelDefs:scenarios":    "/channel-defs/<id>/scenarios/",
    "channelDefs:list-channels":"/channel-defs/<id>/apps/",
    "channelDefs:developer-create":"/channel-defs/<id>/add-app/",

    "channelDefVersions:list":  "/channel-defs/<id>/versions/",
    "channelDefVersions:config":"/channel-defs/<id>/versions/config/",
    "channelDefVersions:edit":  "/channel-defs/<channelDef_id>/versions/<id>/edit/",
    "channelDefVersions:diff":  "/channel-defs/<channelDef_id>/versions/<id>/diff/",
    "channelDefVersions:diffTo":  "/channel-defs/<channelDef_id>/versions/<id>/diff/<diffId>/",
    "channelDefVersions:view":  "/channel-defs/<channelDef_id>/versions/<id>/",



    "channelScriptDefs:list":     "/channel-defs/<id>/scripts/",
    "channelScriptDefs:edit":     "/channel-defs/<channelDef_id>/scripts/<id>/edit/",
    "channelScriptDefs:view":     "/channel-defs/<channelDef_id>/scripts/<id>/",
    "channelScriptDefs:create":   "/channel-defs/<id>/scripts/add/",

    "addonDefs:list":           "/addon-defs/",
    "addonDefs:edit":           "/addon-defs/<id>/edit/",
    "addonDefs:view":           "/addon-defs/<id>/",
    "addonDefs:create":         "/addon-defs/add/",

    "profileDefs:list":         "/profile-defs/",
    "profileDefs:edit":         "/profile-defs/<id>/edit/",
    "profileDefs:view":         "/profile-defs/<id>/",
    "profileDefs:create":       "/profile-defs/add/",

    "profileItemDefs:list":     "/profile-defs/<id>/",
    "profileItemDefs:edit":     "/profile-defs/<profileDef_id>/items/<id>/edit/",
    "profileItemDefs:view":     "/profile-defs/<profileDef_id>/items/<id>/",
    "profileItemDefs:create":   "/profile-defs/<id>/items/add/",

    "coordinationDefs:list":      "/coordination-defs/",
    "coordinationDefs:edit":      "/coordination-defs/<id>/edit/",
    "coordinationDefs:view":      "/coordination-defs/<id>/",
    "coordinationDefs:create":    "/coordination-defs/add/",

    "flowDefs:list":            "/flow-defs/",
    "flowDefs:edit":            "/flow-defs/<id>/edit/",
    "flowDefs:list-flows":      "/flow-defs/<id>/flows/",
    "flowDefs:view":            "/flow-defs/<id>/",
    "flowDefs:create":          "/flow-defs/add/",

    "flowDefVersions:list-all": "/flow-defs-versions/",
    "flowDefVersions:list-all-yes":"/flow-defs-versions/yes/",
    "flowDefVersions:list-all-no":"/flow-defs-versions/no/",
    "flowDefVersions:list-all-undecided":"/flow-defs-versions/-/",

    "channelDefVersions:list-all": "/channel-defs-versions/",
    "channelDefVersions:list-all-yes":"/channel-defs-versions/yes/",
    "channelDefVersions:list-all-no":"/channel-defs-versions/no/",
    "channelDefVersions:list-all-undecided":"/channel-defs-versions/-/",

    "flowDefVersions:list":     "/flow-defs/<id>/versions/",
    "flowDefVersions:config":   "/flow-defs/<id>/versions/config/",
    "flowDefVersions:upgrade":   "/flow-defs/<id>/versions/upgrade/",
    "flowDefVersions:edit":     "/flow-defs/<flowDef_id>/versions/<id>/edit/",
    "flowDefVersions:diff":     "/flow-defs/<flowDef_id>/versions/<id>/diff/",
    "flowDefVersions:diffTo":     "/flow-defs/<flowDef_id>/versions/<id>/diff/<diffId>/",
    "flowDefVersions:view":     "/flow-defs/<flowDef_id>/versions/<id>/",

    "flowBillingRules:list":     "/flow-defs/<id>/billing-rules/",
    "flowBillingRules:create":   "/flow-defs/<id>/billing-rules/add/",
    "flowBillingRules:edit":     "/flow-defs/<flowDef_id>/billing-rules/<id>/edit/",
    "flowBillingRules:view":     "/flow-defs/<flowDef_id>/billing-rules/<id>/",

    "flowChannelDefs:list":     "/flow-defs/<id>/channels/",
    "flowChannelDefs:edit":     "/flow-defs/<flowDef_id>/channels/<id>/edit/",
    "flowChannelDefs:view":     "/flow-defs/<flowDef_id>/channels/<id>/",
    "flowChannelDefs:create":   "/flow-defs/<id>/channels/add/",

    "flowScriptDefs:list":     "/flow-defs/<id>/scripts/",
    "flowScriptDefs:edit":     "/flow-defs/<flowDef_id>/scripts/<id>/edit/",
    "flowScriptDefs:view":     "/flow-defs/<flowDef_id>/scripts/<id>/",
    "flowScriptDefs:create":   "/flow-defs/<id>/scripts/add/",

    "flowExtensionLinkDefs:list":  "/flow-defs/<id>/extension-links/",
    "flowExtensionLinkDefs:edit":  "/flow-defs/<flowDef_id>/extension-links/<id>/edit/",
    "flowExtensionLinkDefs:view":  "/flow-defs/<flowDef_id>/extension-links/<id>/",
    "flowExtensionLinkDefs:create":"/flow-defs/<id>/extension-links/add/",

    "flowStepDefs:list":        "/flow-defs/<id>/steps/",
    "flowStepDefs:edit":        "/flow-defs/<flowDef_id>/steps/<id>/edit/",
    "flowStepDefs:config":      "/flow-defs/<flowDef_id>/steps/<id>/config/",
	"flowStepDefs:delete":      "/flow-defs/<flowDef_id>/steps/<id>/delete/",
    "flowStepDefs:view":        "/flow-defs/<flowDef_id>/steps/<id>/",
    "flowStepDefs:retry-emails":"/flow-defs/<flowDef_id>/steps/<id>/retry-emails/",
    "flowStepDefs:create":      "/flow-defs/<id>/steps/add/",

    "flowStepLinkDefs:list":    "/flow-defs/<flowDef_id>/steps/<id>/",
    "flowStepLinkDefs:edit":    "/flow-defs/<flowDef_id>/steps/<flowStepDef_id>/links/<id>/edit/",
    "flowStepLinkDefs:view":    "/flow-defs/<flowDef_id>/steps/<flowStepDef_id>/links/<id>/",
    "flowStepLinkDefs:create":  "/flow-defs/<flowDef_id>/steps/<id>/links/add/",

    "flowOptionDefs:list":       "/flow-defs/<id>/options/",
    "flowOptionDefs:edit":       "/flow-defs/<flowDef_id>/options/<id>/edit/",
    "flowOptionDefs:view":       "/flow-defs/<flowDef_id>/options/<id>/",
    "flowOptionDefs:create":     "/flow-defs/<id>/options/add/",

    "flowOptionDocDefs:list":    "/flow-defs/<flowDef_id>/options/<id>/docs/",
    "flowOptionDocDefs:edit":    "/flow-defs/<flowDef_id>/options/<flowOptionDef_id>/docs/<id>/edit/",
    "flowOptionDocDefs:view":    "/flow-defs/<flowDef_id>/options/<flowOptionDef_id>/docs/<id>/",
    "flowOptionDocDefs:create":  "/flow-defs/<flowDef_id>/options/<id>/docs/add/",


    "flowCoordinationHooks:list":       "/flow-defs/<id>/coordination-hooks/",
    "flowCoordinationHooks:edit":       "/flow-defs/<flowDef_id>/coordination-hooks/<id>/edit/",
    "flowCoordinationHooks:view":       "/flow-defs/<flowDef_id>/coordination-hooks/<id>/",
    "flowCoordinationHooks:create":     "/flow-defs/<id>/coordination-hooks/add/",

    "flowCoordinationEvents:list":       "/flow-defs/<id>/coordination-events/",
    "flowCoordinationEvents:edit":       "/flow-defs/<flowDef_id>/coordination-events/<id>/edit/",
    "flowCoordinationEvents:view":       "/flow-defs/<flowDef_id>/coordination-events/<id>/",
    "flowCoordinationEvents:create":     "/flow-defs/<id>/coordination-events/add/",

    "flowOptionGroupDefs:list":  "/flow-defs/<id>/option-groups/",
    "flowOptionGroupDefs:edit":  "/flow-defs/<flowDef_id>/option-groups/<id>/edit/",
    "flowOptionGroupDefs:view":  "/flow-defs/<flowDef_id>/option-groups/<id>/",
    "flowOptionGroupDefs:create":"/flow-defs/<id>/option-groups/add/",

    "flowStepConfigDefs:list":  "/flow-defs/<id>/configs/",
    "flowStepConfigDefs:edit":  "/flow-defs/<flowDef_id>/configs/<id>/edit/",
    "flowStepConfigDefs:config":"/flow-defs/<flowDef_id>/configs/<id>/config/",
    "flowStepConfigDefs:view":  "/flow-defs/<flowDef_id>/configs/<id>/",
    "flowStepConfigDefs:create":"/flow-defs/<id>/configs/add/",

    "forms:list":               "/flow-defs/<id>/forms/",
    "forms:edit":               "/flow-defs/<flowDef_id>/forms/<id>/edit/",
    "forms:view":               "/flow-defs/<flowDef_id>/forms/<id>/",
    "forms:create":             "/flow-defs/<id>/forms/add/",

    "formFields:list":          "/flow-defs/<flowDef_id>/forms/<id>/",
    "formFields:edit":          "/flow-defs/<flowDef_id>/forms/<form_id>/fields/<id>/edit/",
    "formFields:view":          "/flow-defs/<flowDef_id>/forms/<form_id>/fields/<id>/",
    "formFields:create":        "/flow-defs/<flowDef_id>/forms/<id>/fields/add/",

    "sourceDefs:list":          "/channel-defs/<id>/",
    "sourceDefs:edit":          "/channel-defs/<channelDef_id>/source-defs/<id>/edit/",
    "sourceDefs:writer":          "/channel-defs/<channelDef_id>/source-defs/<id>/writer/",
    "sourceDefs:view":          "/channel-defs/<channelDef_id>/source-defs/<id>/",
    "sourceDefs:create":        "/channel-defs/<id>/source-defs/add/",

    "sourceDefOperations:list":  "/channel-defs/<channelDef_id>/source-defs/<id>/operations/",
    "sourceDefOperations:edit":  "/channel-defs/<channelDef_id>/source-defs/<sourceDef_id>/operations/<id>/edit/",
    "sourceDefOperations:view":  "/channel-defs/<channelDef_id>/source-defs/<sourceDef_id>/operations/<id>/",
    "sourceDefOperations:create":"/channel-defs/<channelDef_id>/source-defs/<id>/operations/add/",

    "actionDefs:list":          "/channel-defs/<id>/action-defs/",
    "actionDefs:edit":          "/channel-defs/<channelDef_id>/action-defs/<id>/edit/",
    "actionDefs:js":            "/channel-defs/<channelDef_id>/action-defs/<id>/js/",
    "actionDefs:view":          "/channel-defs/<channelDef_id>/action-defs/<id>/",
    "actionDefs:create":        "/channel-defs/<id>/action-defs/add/",

    "actionInputDefs:list":     "/channel-defs/<channelDef_id>/action-defs/<id>/inputs/",
    "actionInputDefs:edit":     "/channel-defs/<channelDef_id>/action-defs/<actionDef_id>/inputs/<id>/edit/",
    "actionInputDefs:view":     "/channel-defs/<channelDef_id>/action-defs/<actionDef_id>/inputs/<id>/",
    "actionInputDefs:create":   "/channel-defs/<channelDef_id>/action-defs/<id>/inputs/add/",

    "channelDefExclusions:list":  "/channel-defs/<id>/exclusions/",
    "channelDefExclusions:edit":  "/channel-defs/<channelDef_id>/exclusions/<id>/edit/",
    "channelDefExclusions:view":  "/channel-defs/<channelDef_id>/exclusions/<id>/",
    "channelDefExclusions:create":"/channel-defs/<id>/exclusions/add/",

    "sourceGroupDefs:list":     "/channel-defs/<id>/source-groups/",
    "sourceGroupDefs:edit":     "/channel-defs/<channelDef_id>/source-groups/<id>/edit/",
    "sourceGroupDefs:view":     "/channel-defs/<channelDef_id>/source-groups/<id>/",
    "sourceGroupDefs:create":   "/channel-defs/<id>/source-groups/add/",


    "channelURLDefs:list":      "/channel-defs/<id>/url-defs/",
    "channelURLDefs:edit":      "/channel-defs/<channelDef_id>/url-defs/<id>/edit/",
    "channelURLDefs:view":      "/channel-defs/<channelDef_id>/url-defs/<id>/",
    "channelURLDefs:create":    "/channel-defs/<id>/url-defs/add/",

    "channelInjectionDefs:list":      "/channel-defs/<id>/injection-defs/",
    "channelInjectionDefs:edit":      "/channel-defs/<channelDef_id>/injection-defs/<id>/edit/",
    "channelInjectionDefs:view":      "/channel-defs/<channelDef_id>/injection-defs/<id>/",
    "channelInjectionDefs:create":    "/channel-defs/<id>/injection-defs/add/",

    "channelErrorDefs:list":      "/channel-defs/<id>/errors/",
    "channelErrorDefs:edit":      "/channel-defs/<channelDef_id>/errors/<id>/edit/",
    "channelErrorDefs:view":      "/channel-defs/<channelDef_id>/errors/<id>/",
    "channelErrorDefs:create":    "/channel-defs/<id>/errors/add/",

    "channelErrors:list":             "/organisations/<organisation_id>/channels/<id>/channel-errors/",
    "channelErrors:list-ok":          "/organisations/<organisation_id>/channels/<id>/channel-errors-ok/",
    "channelErrors:list-fail":        "/organisations/<organisation_id>/channels/<id>/channel-errors-fail/",
    "channelErrors:list-ignored":     "/organisations/<organisation_id>/channels/<id>/channel-errors-ignored/",
    "channelErrors:list-forever":     "/organisations/<organisation_id>/channels/<id>/channel-errors-forever/",
    "channelErrors:list-flow":        "/organisations/<organisation_id>/flows/<id>/channel-errors/",
    "channelErrors:list-flow-ok":     "/organisations/<organisation_id>/flows/<id>/channel-errors-ok/",
    "channelErrors:list-flow-fail":   "/organisations/<organisation_id>/flows/<id>/channel-errors-fail/",
    "channelErrors:list-flow-ignored":"/organisations/<organisation_id>/flows/<id>/channel-errors-ignored/",
    "channelErrors:list-flow-forever":"/organisations/<organisation_id>/flows/<id>/channel-errors-forever/",
    "channelErrors:list-user":        "/settings/channel-errors/",
    "channelErrors:list-user-ok":     "/settings/channel-errors-ok/",
    "channelErrors:list-user-fail":   "/settings/channel-errors-fail/",
    "channelErrors:list-user-ignored":"/settings/channel-errors-ignored/",
    "channelErrors:list-user-forever":"/settings/channel-errors-forever/",
    "channelErrors:list-consultant":        "/settings/consultants/channel-errors/",
    "channelErrors:list-consultant-ok":     "/settings/consultants/channel-errors-ok/",
    "channelErrors:list-consultant-fail":   "/settings/consultants/channel-errors-fail/",
    "channelErrors:list-consultant-ignored":"/settings/consultants/channel-errors-ignored/",
    "channelErrors:list-consultant-forever":"/settings/consultants/channel-errors-forever/",
    "channelErrors:list-org":         "/organisations/<id>/channel-errors/",
    "channelErrors:list-org-ok":      "/organisations/<id>/channel-errors-ok/",
    "channelErrors:list-org-fail":    "/organisations/<id>/channel-errors-fail/",
    "channelErrors:list-org-ignored": "/organisations/<id>/channel-errors-ignored/",
    "channelErrors:list-org-forever": "/organisations/<id>/channel-errors-forever/",
    "channelErrors:list-channelDef":  "/channel-defs/<id>/channel-errors/",
    "channelErrors:list-channelDef-ok":"/channel-defs/<id>/channel-errors-ok/",
    "channelErrors:list-channelDef-fail":"/channel-defs/<id>/channel-errors-fail/",
    "channelErrors:list-channelDef-ignored":"/channel-defs/<id>/channel-errors-ignored/",
    "channelErrors:list-channelDef-forever":"/channel-defs/<id>/channel-errors-forever/",
    "channelErrors:list-flowDef":     "/flow-defs/<id>/channel-errors/",
    "channelErrors:list-flowDef-ok":  "/flow-defs/<id>/channel-errors-ok/",
    "channelErrors:list-flowDef-fail":"/flow-defs/<id>/channel-errors-fail/",
    "channelErrors:list-flowDef-ignored":"/flow-defs/<id>/channel-errors-ignored/",
    "channelErrors:list-flowDef-forever":"/flow-defs/<id>/channel-errors-forever/",
    "channelErrors:view":             "/organisations/<organisation_id>/channels/<channel_id>/channel-errors/<id>/",

    "channelErrors:list-user-type":        "/settings/channel-errors-type/",
    "channelErrors:list-org-type":        "/organisations/<id>/channel-errors-type/",
    "channelErrors:list-flow-type":        "/organisations/<organisation_id>/flows/<id>/channel-errors-type/",

    "channelOptionDefs:list":   "/channel-defs/<id>/option-defs/",
    "channelOptionDefs:edit":   "/channel-defs/<channelDef_id>/option-defs/<id>/edit/",
    "channelOptionDefs:view":   "/channel-defs/<channelDef_id>/option-defs/<id>/",
    "channelOptionDefs:create": "/channel-defs/<id>/option-defs/add/",

    "channelMappingDefs:list":  "/channel-defs/<id>/mapping-defs/",
    "channelMappingDefs:edit":  "/channel-defs/<channelDef_id>/mapping-defs/<id>/edit/",
    "channelMappingDefs:view":  "/channel-defs/<channelDef_id>/mapping-defs/<id>/",
    "channelMappingDefs:create":"/channel-defs/<id>/mapping-defs/add/",

    "channelEntityDefs:list":   "/channel-defs/<id>/entity-mapping/",
    "channelEntityDefs:edit":   "/channel-defs/<channelDef_id>/entity-mapping/<id>/edit/",
    "channelEntityDefs:copy":   "/channel-defs/<channelDef_id>/entity-mapping/<id>/copy/",
    "channelEntityDefs:view":   "/channel-defs/<channelDef_id>/entity-mapping/<id>/",
    "channelTypeConversionDefs:list":  "/channel-defs/<id>/type-conversions/",
    "channelTypeConversionDefs:edit":  "/channel-defs/<channelDef_id>/type-conversions/<id>/edit/",
    "channelTypeConversionDefs:create":"/channel-defs/<id>/type-conversions/add/",
    "channelTypeConversionDefs:view":  "/channel-defs/<channelDef_id>/type-conversions/<id>/",

    "channelEntityDefs:editFieldDef":"/channel-defs/<channelDef_id>/entity-mapping/<channelEntityDef_id>/field/<entityDef_id>/<fieldDef_id>/",
    "channelEntityDefs:createFieldDef":"/channel-defs/<channelDef_id>/entity-mapping/<channelEntityDef_id>/field/create/",
    "channelEntityDefs:editChannelField":"/channel-defs/<channelDef_id>/entity-mapping/<channelEntityDef_id>/cfd/<channelFieldDef_id>/edit/",
    "channelEntityDefs:replaceChannelField":"/channel-defs/<channelDef_id>/entity-mapping/<channelEntityDef_id>/cfd/<channelFieldDef_id>/replace/",
    "channelEntityDefs:createChannelField":"/channel-defs/<channelDef_id>/entity-mapping/<channelEntityDef_id>/cfd/create/",
    "channelEntityDefs:create": "/channel-defs/<id>/entity-mapping/add/",

    "channelFieldDefs:list":    "/channel-defs/<channelDef_id>/entity-mapping/<id>/",
    "channelFieldDefs:view":    "/channel-defs/<channelDef_id>/entity-mapping/<id>/",
    "channelFieldDefs:edit":    "/channel-defs/<channelDef_id>/entity-mapping/<id>/fields/edit/",

    "channelRelationDefs:list": "/channel-defs/<id>/relations/",
    "channelRelationDefs:edit": "/channel-defs/<channelDef_id>/relations/<id>/edit/",
    "channelRelationDefs:view": "/channel-defs/<channelDef_id>/relations/<id>/",
    "channelRelationDefs:create":"/channel-defs/<id>/relations/add/",

    /* metamodel definition */
    "developerGroups:list":     "/developer/",
    "developerGroups:edit":     "/developer/<id>/edit/",
    "developerGroups:view":     "/developer/<id>/",
    "developerGroups:create":   "/developer/add/",

    "instances:list":           "/instances/",
    "instances:edit":           "/instances/<id>/edit/",
    "instances:fetch-stats":    "/instances/<id>/fetch-stats/",
    "instances:view":           "/instances/<id>/",
    "instances:emails":         "/instances/<id>/emails",
    "instances:create":         "/instances/add/",

    "runningJobs:list":         "/instances/<id>/running-jobs/",
    "runningJobs:view":         "/instances/<instance_id>/running-jobs/<id>/",

    "instanceScenarios:list":   "/instances/<id>/scenarios/",
    "instanceScenarios:edit":   "/instances/<instance_id>/scenarios/<id>/edit/",
    "instanceScenarios:view":   "/instances/<instance_id>/scenarios/<id>/",
    "instanceScenarios:create": "/instances/<id>/scenarios/add/",

    "groupDefs:list":           "/group-defs/",
    "groupDefs:edit":           "/group-defs/<id>/edit/",
    "groupDefs:view":           "/group-defs/<id>/",
    "groupDefs:create":         "/group-defs/add/",

    "groupDefVersions:list":    "/group-defs/<id>/versions/",
    "groupDefVersions:config":  "/group-defs/<id>/versions/config/",
    "groupDefVersions:edit":    "/group-defs/<groupDef_id>/versions/<id>/edit/",
    "groupDefVersions:diff":    "/group-defs/<groupDef_id>/versions/<id>/diff/",
    "groupDefVersions:diffTo":    "/group-defs/<groupDef_id>/versions/<id>/diff/<diffId>/",
    "groupDefVersions:view":    "/group-defs/<groupDef_id>/versions/<id>/",

    "libraryDefs:list":           "/library-defs/",
    "libraryDefs:edit":           "/library-defs/<id>/edit/",
    "libraryDefs:view":           "/library-defs/<id>/",
    "libraryDefs:create":         "/library-defs/add/",

    "libraryDefVersions:list":    "/library-defs/<id>/versions/",
    "libraryDefVersions:config":  "/library-defs/<id>/versions/config/",
    "libraryDefVersions:edit":    "/library-defs/<libraryDef_id>/versions/<id>/edit/",
    "libraryDefVersions:diff":    "/library-defs/<libraryDef_id>/versions/<id>/diff/",
    "libraryDefVersions:diffTo":    "/library-defs/<libraryDef_id>/versions/<id>/diff/<diffId>/",
    "libraryDefVersions:view":    "/library-defs/<libraryDef_id>/versions/<id>/",

    "entityDefs:channel-list":  "/channel-defs/<id>/entity-defs/",
    "entityDefs:list":          "/group-defs/<groupDef_id>/entity-defs/",
    "entityDefs:edit":          "/group-defs/<groupDef_id>/entity-defs/<id>/edit/",
    "entityDefs:view":          "/group-defs/<groupDef_id>/entity-defs/<id>/",
    "entityDefs:create":        "/group-defs/<id>/entity-defs/add/",

    "fieldDefs:list":           "/entity-defs/<id>/",
    "fieldDefs:edit":           "/entity-defs/<entityDef_id>/field-defs/<id>/edit/",
    "fieldDefs:refactor":       "/entity-defs/<entityDef_id>/field-defs/<id>/refactor/",
    "fieldDefs:move":           "/entity-defs/<entityDef_id>/field-defs/<id>/move/",
    "fieldDefs:view":           "/entity-defs/<entityDef_id>/field-defs/<id>/",
    "fieldDefs:create":         "/entity-defs/<id>/field-defs/add/",

    "operationDefs:list":       "/entity-defs/<id>/operations/",
    "operationDefs:edit":       "/entity-defs/<entityDef_id>/operations/<id>/edit/",
    "operationDefs:view":       "/entity-defs/<entityDef_id>/operations/<id>/",
    "operationDefs:create":     "/entity-defs/<id>/operations/add/",

    "entityViewDefs:list":      "/entity-defs/<id>/views/",
    "entityViewDefs:edit":      "/entity-defs/<entityDef_id>/views/<id>/edit/",
    "entityViewDefs:view":      "/entity-defs/<entityDef_id>/views/<id>/",
    "entityViewDefs:create":    "/entity-defs/<id>/views/add/",

    "screenBoxToAdd:list":      "/entity-defs/<id>/boxes/",

    "screenDefs:list":          "/entity-defs/<id>/screen-defs/",
    "screenDefs:edit":          "/entity-defs/<entityDef_id>/screen-defs/<id>/edit/",
    "screenDefs:view":          "/entity-defs/<entityDef_id>/screen-defs/<id>/",
    "screenDefs:create":        "/entity-defs/<id>/screen-defs/add/",

    "entityInheritanceDefs:list":  "/entity-defs/<id>/",
    "entityInheritanceDefs:edit":  "/entity-defs/<entityDef_id>/inheritance/<id>/edit/",
    "entityInheritanceDefs:view":  "/entity-defs/<entityDef_id>/inheritance/<id>/",
    "entityInheritanceDefs:create":"/entity-defs/<id>/inheritance/add/",

    "entityRelationDefs:list":  "/entity-defs/<id>/relation/",
    "entityRelationDefs:edit":  "/entity-defs/<entityDef_id>/relation/<id>/edit/",
    "entityRelationDefs:view":  "/entity-defs/<entityDef_id>/relation/<id>/",
    "entityRelationDefs:create":"/entity-defs/<id>/relation/add/",

    "scenarioDefs:list":           "/scenario-defs/",
    "scenarioDefs:list-draft":     "/scenario-defs/filter-draft/",
    "scenarioDefs:list-unsupported":"/scenario-defs/filter-unsupported/",
    "scenarioDefs:list-published": "/scenario-defs/filter-published/",
    "scenarioDefs:list-beta":      "/scenario-defs/filter-beta/",
    "scenarioDefs:list-alpha":     "/scenario-defs/filter-alpha/",
    "scenarioDefs:list-visible":   "/scenario-defs/filter-visible/",
    "scenarioDefs:list-deprecated":"/scenario-defs/filter-deprecated/",
    "scenarioDefs:edit":           "/scenario-defs/<id>/edit/",
    "scenarioDefs:scenarios":      "/scenario-defs/<id>/scenarios/",
    "scenarioDefs:view":           "/scenario-defs/<id>/",
    "scenarioDefs:create":         "/scenario-defs/add/",

    "scenarioDefVersions:list":    "/scenario-defs/<id>/versions/",
    "scenarioDefVersions:edit":    "/scenario-defs/<scenarioDef_id>/versions/<id>/edit/",
    "scenarioDefVersions:diff":    "/scenario-defs/<scenarioDef_id>/versions/<id>/diff/",
    "scenarioDefVersions:diffTo":    "/scenario-defs/<scenarioDef_id>/versions/<id>/diff/<diffId>/",
    "scenarioDefVersions:view":    "/scenario-defs/<scenarioDef_id>/versions/<id>/",

    "scenarios:list":               "/scenario-defs/<scenarioDef_id>/scenarios/",
    "scenarios:list-all":           "/s/",
    "scenarios:list-search":        "/s/search/<searchName>/",
    "scenarios:view":               "/s/<urlFragment>/",
    "scenarios:scenario-apply-pre": "/s/<urlFragment>/apply/",

    "scenarioChannelDefRules:list": "/scenario-defs/<id>/rule/",
    "scenarioChannelDefRules:edit": "/scenario-defs/<scenarioDef_id>/rule/<id>/edit/",
    "scenarioChannelDefRules:view": "/scenario-defs/<scenarioDef_id>/rule/<id>/",
    "scenarioChannelDefRules:create":"/scenario-defs/<id>/rule/add/",

    "scenarioFlowDefs:list":        "/scenario-defs/<id>/flows/",
    "scenarioFlowDefs:edit":        "/scenario-defs/<scenarioDef_id>/flows/<id>/edit/",
    "scenarioFlowDefs:view":        "/scenario-defs/<scenarioDef_id>/flows/<id>/",
    "scenarioFlowDefs:create":      "/scenario-defs/<id>/flows/add/",

    "scenarioScreenDefs:list":  "/scenario-defs/<id>/screen/",
    "scenarioScreenDefs:edit":  "/scenario-defs/<scenarioDef_id>/screen/<id>/edit/",
    "scenarioScreenDefs:view":  "/scenario-defs/<scenarioDef_id>/screen/<id>/",
    "scenarioScreenDefs:create":"/scenario-defs/<id>/screen/add/",
    "entitySelectionRules:edit":"/scenario-defs/<scenarioDef_id>/screen/<scenarioScreenDef_id>/data-sources/<dataSource_id>/rules/<id>/",


    "panel:no-screen":           "/panel/organisations/<organisation_id>/channels/<channel_id>/panel/no-screen/",
	"panel:loading-panel":       "/panel/organisations/<organisation_id>/channels/<channel_id>/panel/loading/",
	"panel:required-caching":    "/panel/organisations/<organisation_id>/channels/<channel_id>/panel/required-caching/<cachingChannel_id>/",
    "panel:create-screen-step-1":"/panel/organisations/<organisation_id>/channels/<channel_id>/panel/create-screen/<channelEntityDef_id>/step-1/",
    "panel:create-screen-step-2":"/panel/organisations/<organisation_id>/channels/<channel_id>/panel/create-screen/<channelEntityDef_id>/step-2/",
	"panel:list-without-panel":  "/panel/list-without-panel/channels/<channelDef_id>/channel-mapping/<channelMappingDef_id>/",
    "panel:panel":               "/panel/organisations/<organisation_id>/channels/<channel_id>/screens/<screen_id>/panel/<data>/",
    "panel:mini":                "/panel/organisations/<organisation_id>/channels/<channel_id>/screens/<screen_id>/mini/<data>/",
    "panel:screen-settings":     "/panel/organisations/<organisation_id>/channels/<channel_id>/screens/<screen_id>/screen-settings/",
	"panel:widget-config":       "/panel/organisations/<organisation_id>/channels/<channel_id>/screens/<screen_id>/widget-config/view/<viewId>/<opener>/",
    "panel:menu":                "/panel/organisations/<organisation_id>/menu/",
    "panel:menu-channel":        "/panel/organisations/<organisation_id>/menu/<id>/",
    "panel:no-channel":          "/panel/no-channel/<channelDef_id>/",
    "panel:empty":               "/panel/empty/",
    "panel:not-logged":          "/panel/not-logged/",
    "panel:error":               "/panel/error/",
    "panel:error-mini":          "/panel/error-mini/",
};

// load your url list
urls.load(myUrls);

const uuidRegex =  /[0-9a-fA-F\-]{30,40}/;

const updateHash = "#update";
// eslint-disable-next-line max-params
function getUrl(metadata, action, args, forceUpdate = false) {
    if (args && args.id) {
        /* is 'id' Relay's globalId? (fromGlobalId/toGlobalId) */
        if ((args.id.length > 30 && !args.id.match(uuidRegex) && args.id.indexOf("|") === -1 && args.id.indexOf("-") === -1)) {
            let {id} = fromGlobalId(args.id);
            /* if ID is JSON, we need to parse it */
            if (id && id.substr(0, 1) === "{" && id.substr(-1, 1) === "}") {
                id = safeJSONparse(id).id;
            }
            args = immutable.Map(args).set('id', id).toObject();
        }
    }

    if (typeof metadata !== "string") {
        metadata = metadata.entity();
    }


    let key = metadata + ':' + action;

    /* crossing fails if we provide variables but URL don't use them */
    let url = myUrls[key];
    // console.log("getUrl", key, url, args);
    let needArgs = url && url.indexOf('<') !== -1;
    if (needArgs && !args) {
        return "/invalid-url";
    }

	let path;
	try {
		path = urls.get(key, needArgs ? args : null);
	}
	catch (e) {
		e.functionArguments = arguments;
		console.error(e); // eslint-disable-line no-console
	}

	if (forceUpdate) {
		path += updateHash;
	}

    return path;
}

function isForceUpdate() {
	return window.location.hash === updateHash;
}

export default {
    getUrl: getUrl,
	isForceUpdate: isForceUpdate
};
